import { Box } from '@alf/uikit';
import { LOG_ACTIONS, useLogAmplitude } from '@namespace/analytics';
import { useGeneralRoutes } from '@namespace/cms';
import { Icon } from '@namespace/icons2';
import { useGetPandascorePageUrl } from '../../../../../../../../hooks/useGetPandascorePageUrl';
import { useEventFields } from '../../../../../../../../store';

import styles from '../../index.module.css';

export const StatisticsIcon = ({
  eventEnetStatUrl,
  eventId,
  amplitudeEntryPoint
}) => {
  const logAmplitude = useLogAmplitude();
  const { cyberSport } = useGeneralRoutes();
  const { sportId, sportName, eventName } = useEventFields({
    eventId,
    fields: ['sportId', 'sportName', 'eventName']
  });

  const handleClick = () => {
    logAmplitude({
      actionName: LOG_ACTIONS.SPORTS_BOOK_STATISTIC_CLICK,
      attributes: {
        entry_point: amplitudeEntryPoint,
        event_id: eventId,
        event_name: eventName,
        sport_id: sportId,
        sport_name: sportName
      },
      isMatchPath: true,
      additionalRoutes: { cybersport: cyberSport }
    });
  };

  const href = useGetPandascorePageUrl(eventEnetStatUrl);

  return (
    <Box align="center" className={styles.filterIcon}>
      <a
        onClick={handleClick}
        href={href}
        rel="noopener noreferrer"
        target="_blank"
      >
        <Icon name="icons/event/statistics" size="l" className={styles.icon} />
      </a>
    </Box>
  );
};
